// Dates are 'YYYY-MM-DD' strings; months are 'YYYY-MM'. "Today" is the date in Europe/Belgrade.
const pad = (n) => String(n).padStart(2, '0');
const utc = (d) => { const [y, m, day] = d.split('-').map(Number); return new Date(Date.UTC(y, m - 1, day)); };
const iso = (dt) => `${dt.getUTCFullYear()}-${pad(dt.getUTCMonth() + 1)}-${pad(dt.getUTCDate())}`;
const parts = (d) => d.split('-').map(Number);

export const MONTHS = ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'];
export const WEEKDAYS = ['P', 'U', 'S', 'Č', 'P', 'S', 'N'];

const belgrade = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Belgrade', year: 'numeric', month: '2-digit', day: '2-digit' });
export const todayBelgrade = (now = new Date()) => belgrade.format(now);

export function addDays(date, n) {
  const dt = utc(date);
  dt.setUTCDate(dt.getUTCDate() + n);
  return iso(dt);
}

export function isDate(s) {
  return typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s) && iso(utc(s)) === s;
}

export const monthOf = (date) => date.slice(0, 7);

export function shiftMonth(month, n) {
  const [y, m] = month.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1 + n, 1));
  return `${dt.getUTCFullYear()}-${pad(dt.getUTCMonth() + 1)}`;
}

export function monthRange(month) {
  return { first: `${month}-01`, last: addDays(`${shiftMonth(month, 1)}-01`, -1) };
}

export function monthTitle(month) {
  const [y, m] = month.split('-').map(Number);
  const name = MONTHS[m - 1];
  return `${name[0].toUpperCase()}${name.slice(1)} ${y}`;
}

// Weeks Monday first, 7 cells each; null for days outside the month.
export function monthGrid(month) {
  const { first, last } = monthRange(month);
  const lead = (utc(first).getUTCDay() + 6) % 7;
  const cells = Array(lead).fill(null);
  for (let d = first; d <= last; d = addDays(d, 1)) cells.push(d);
  while (cells.length % 7) cells.push(null);
  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));
  return weeks;
}

export function fmtDate(date) {
  const [y, m, d] = parts(date);
  return `${d}. ${m}. ${y}.`;
}

export function fmtRange(s, e) {
  if (s === e) return fmtDate(s);
  const [sy, sm, sd] = parts(s);
  const [ey, em, ed] = parts(e);
  if (sy === ey && sm === em) return `${sd}.–${ed}. ${sm}. ${sy}.`;
  if (sy === ey) return `${sd}. ${sm}. – ${ed}. ${em}. ${ey}.`;
  return `${fmtDate(s)} – ${fmtDate(e)}`;
}

export function fmtDayTitle(date) {
  const [, m, d] = parts(date);
  return `${d}. ${MONTHS[m - 1]}`;
}

const asOfParts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Belgrade', day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
export function fmtAsOf(isoString) {
  const p = Object.fromEntries(asOfParts.formatToParts(new Date(isoString)).map((x) => [x.type, x.value]));
  return `${Number(p.day)}. ${Number(p.month)}. u ${p.hour}:${p.minute}`;
}
